export const validHexColor = (color) => /^#[0-9A-F]{6}$/i.test(color) || /^#[0-9A-F]{3}$/i.test(color)
